var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/card-msg-evaluate1.html');
var config = require('../../global/config');
var ActionType = require('../../constant/ActionType'); 
var dispatcher = require('../../global/dispatcher');
var isClicked = false;
var CardMsgEvaluate1 = function (options){
    (function(self){
        var defaults ={
            template:template
        };
        $.extend(defaults,options);
        BaseMsgItem.call(self,defaults);
        let inputDiv =self._element.find('.im-evaluate1-input');
        inputDiv.keydown(()=>{
            let len = inputDiv.val().length
            if(len>140){
                inputDiv.attr("readonly","readonly")
                var text = '超过可输入的最大字符数，请重新输入！';
                dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                        content: text,
                        interval: 2000
                    }
                }); 
            }
        })
    })(this);
};
//渲染星级评价区域
const genFragment=({title,starNum,activeNum,idx})=>{
    var fragment =$('<div></div>')
    
    var $contentItem=$('<div></div>');//创建元素,返回jQuery对象
    $contentItem.addClass('im-evaluate1-star-item')
    $contentItem.attr('idx',idx)
    
    var $titleDom=$('<div></div>');//创建元素,返回jQuery对象
    $titleDom.addClass('im-evaluate1-star-name')
    $titleDom.text(title)

    var $startWrap=$('<div></div>');//创建元素,返回jQuery对象
    $startWrap.addClass('im-evaluate1-star-starWrap')
      for(let i=0;i<starNum;i++){
        var $span=$('<span></span>');//创建元素,返回jQuery对象
        $span.addClass('im-evaluate1-content-star')
        let starIndex = i+ idx *5
        $span.attr('starIndex',starIndex)
        $span.attr('idx',idx)
        i==starNum-1 && $span.addClass('last-evaluate1-star')
        if(i<activeNum){
            $span.addClass('star-active')
        }
        fragment.append($span);
    }
      $startWrap.append(fragment);
      $contentItem.append($titleDom);
      $contentItem.append($startWrap);
      return $contentItem
}
CardMsgEvaluate1.prototype = Object.create(BaseMsgItem.prototype);
CardMsgEvaluate1.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  let starStatus=[]
  //数据
  var content = msg.content;
  let evalData =JSON.parse(JSON.stringify(content))
  var element = this._element;
  if(evalData && !evalData.dimensions){
    return false
}
//获取dom
const starContent = element.find('.star-content');
const titleDiv = element.find('.im-evaluate1-title');
const titleDiv2 = element.find('.im-evaluate1-title2');
const sendBtn = element.find('.send-content');
const smileContent = element.find('.smile-content');
const tagContent = element.find('.tag-content');
const inputContent = element.find('.input-content');

//提交
const sendHandle =(e)=>{
    e.stopPropagation();
    if(!isClicked){
        return
    }
    //评价结果
    let inputValue =inputContent.find(".im-evaluate1-input").val()
    if(evalData.remark_info && evalData.remark_info.required === 1){//必须填写补充评价
        if(inputValue === ""){
            //提示必须填写补充评价
            var text = '写一下您的宝贵意见吧！';
                dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                        content: text,
                        interval: 2000
                    }
                }); 
            return 
        }
    }
    let evaluateResult={//评价结果
        "extra":evalData.extra,//可选字段，业务侧透传信息
        "dimensions":starStatus,
        "remark": '' || inputValue
    }
    //评价结果字段
    let sendMsg={ 
        "msg_id":msg.msg_id,//评价消息卡片的msg_id
        "sender_id":msg.sender_id,//评价卡片消息的其他字段
        "sender_source":msg.sender_source,
        "to_id":msg.to_id,
        "to_source":msg.to_source,
        "show_type":evalData.type,
        "bus_scene":evalData.bus_scene,//业务场景，不同业务场景的评价结果可能会方到不同的消息总线，业务侧通过消息总线监听结果。
        "result":evaluateResult
    }
    let updateMsg = JSON.parse(JSON.stringify(msg))
    updateMsg.content.result=evaluateResult;
    let evaluateMsg = {
        sendMsg:sendMsg,
        updateMsg:updateMsg
    }
    dispatcher.dispatch({
        type: ActionType.SET_EVALUATE,
        data: evaluateMsg
    }); 
    sendBtn.text("感谢您的评价，这将帮助我们做得更好");
    sendBtn.off('click',sendHandle)
    starContent.off('click',starBoxHandle)
    sendBtn.css('color','rgba(153,153,153,1)')
    element.find('.im-evaluate1-input').attr("disabled","disabled")
};
//点击星星事件
const starBoxHandle=(event)=>{
    event.stopPropagation();
    var $clickDom = $(event.target) || $(window.event.srcElement)

    if(! $clickDom.hasClass('im-evaluate1-content-star')){
        return false
    }

    let index = parseInt($clickDom.attr('starIndex'))
    let colIndex = parseInt($clickDom.attr('idx'));
    let titleName = evalData.dimensions[colIndex].title;
    let $starWrapDom = $clickDom.parent().children();
    let m =index-colIndex*5+1;
    let starRes={
        "idx":colIndex,
        "title":titleName,
        "score":m
    }
    starStatus[colIndex]=starRes;
    for(let i=0;i<5;i++){
        $($starWrapDom[i]).removeClass('star-active')
        if(i<m ){
            $($starWrapDom[i]).addClass('star-active')
        }
    }
    sendBtn.css('color','rgba(33, 187, 247, 1)');
    isClicked = true;
}
    //渲染title
    let title = evalData.title ?evalData.title:'';
    titleDiv.text(title);
    titleDiv2.text("匿名评价,请放心填写");
    //没有评价状态，
    if(evalData.status === 0){
        //渲染评价区域
        if(evalData.dimensions && evalData.dimensions !==''){
            let len = evalData.dimensions ? evalData.dimensions.length:'';
            for(let i=0;i<len;i++){
                let title = evalData.dimensions[i].title;
                let idx = evalData.dimensions[i].idx;
                starStatus[i]={
                    idx:idx,
                    title:title,
                    score:0
                }
                let contentItem = genFragment({title:title,starNum:5,activeNum:0,idx:idx})
                starContent.append(contentItem)
            }
        }   
        //是否需要补充评价,有限制的最大字数 
        if(evalData.remark_info && evalData.remark_info === ''){
            inputContent.css('display','none')
        }
        //绑定事件
        starContent.on('click',starBoxHandle)
        sendBtn.on('click',sendHandle);
    }else{
        //星级评价结果
        if(evalData && !evalData.result){
            return false
        }
        let resData = evalData.result.dimensions?evalData.result.dimensions:'';
        let len = resData.length;
        for(let j=0;j<len;j++){
            let title = resData[j].title || '';
            let contentItem = genFragment({title:title,starNum:5,activeNum:resData[j].score,idx:resData[j].idx})
            starContent.append(contentItem)
        }
        //输入框
        let inputDom=element.find('.im-evaluate1-input');
        if(evalData.result && evalData.result.remark){
            inputContent.css('display','flex')
            inputDom.remove()
            inputContent.append($('<div class = "im-input-has-evaluate"></div>').text(evalData.result.remark))
            //inputDom.attr("value",evalData.result.remark);
            //inputDom.attr("disabled","disabled");       
        }else{
            inputContent.hide();
        }
        //提交
        sendBtn.text("感谢您的评价，这将帮助我们做得更好");
        sendBtn.css('color','rgba(153,153,153,1)')
        starContent.off('click',starBoxHandle)
    } 
};

module.exports = CardMsgEvaluate1;